import camelcaseKeys from 'camelcase-keys'
import { WebappPage } from '@/entities/webapp-pages/WebappPage'

export class PageObjectRelatedPage {
  constructor (params = {}) {
    const { originalPageId, relatedPageId, order, relatedPage } = camelcaseKeys(params ? params : {})
    this.originalPageId = originalPageId
    this.relatedPageId = relatedPageId
    this.order = order || 0
    this.page = relatedPage ? new WebappPage(relatedPage) : null
  }
}
